import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

//Components
import Navbar from './Navbar';
import Post from './Post';

// Style & Assets
import style from '../assets/style/Post.module.css';

const PostModal = (props) => {
  const navigate = useNavigate();
  let params = useParams();
  const [post, setPost] = useState('');
  const [loading, setLoading] = useState(true);
  const [, setStickyModalOpen] = useState(false);

  // Get Post Data
  useEffect(() => {
    axios({
      method: 'get',
      url: '/getPost',
      withCredentials: true,
      params: {
        postID: params.postID,
      },
    })
      .then(function (res) {
        if (res.status === 200) {
          setPost(res.data[0]);
          setLoading(false);
        } else {
          navigate('/feed');
        }
      })
      .catch((error) => {
        // If 401 Unauthorized
        if (error.response && error.response.status === 401) {
          navigate('/');
          return;
        }
        // For any other error, go back to feed
        navigate('/feed');
      });
  }, [navigate, params.postID]);

  function removePostFromFeed(postID) {
    // Navigate back to feed when post is deleted
    navigate('/feed');
  }

  function goBack() {
    navigate(-1); // Go back to previous page
  }

  if (loading) {
    return (
      <div>
        {props.isPage && <Navbar user={props.user} />}
        <div className={style.postPage}>
          <div className="main-loading">
            <div className="loading-spinner">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="72"
                height="72"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-loader-circle"
              >
                <path d="M21 12a9 9 0 1 1-6.219-8.56" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      {props.isPage && <Navbar user={props.user} />}
      <div className={style.postPage}>
        <div
          style={{
            marginBottom: '1rem',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <button
            onClick={goBack}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '1.5rem',
              cursor: 'pointer',
              padding: '0.5rem',
              display: 'flex',
              alignItems: 'center',
              color: 'var(--DarkGray)',
            }}
          >
            ← Back
          </button>
        </div>

        {post ? (
          <Post
            user={props.user}
            post={post}
            removePostFromFeed={removePostFromFeed}
            setStickyModalOpen={setStickyModalOpen}
          />
        ) : (
          <div style={{ textAlign: 'center', padding: '2rem' }}>
            <h3>No Post Found</h3>
            <p>
              This post may have been deleted or you don't have permission to
              view it.
            </p>
            <button
              onClick={goBack}
              style={{
                padding: '0.5rem 1rem',
                backgroundColor: 'var(--PrimaryRed)',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                marginTop: '1rem',
              }}
            >
              Go Back
            </button>
          </div>
        )}
      </div>
      <div style={{ height: '3rem' }}></div>
    </div>
  );
};

export default PostModal;
